// components/PresetCard.tsx
import React from 'react';
import { Box, Text, Flex, Badge, Icon, Button, HStack } from '@chakra-ui/react';
import { Check, Trash2 } from 'lucide-react';
import { UserFeedPreference } from '../../../apis/user-preferences';

interface PresetCardProps {
  preset: UserFeedPreference;
  isActive: boolean;
  isCustom?: boolean;
  icon: React.ReactElement;
  onSelect: () => void;
  onDelete?: () => void;
  handleViewSettings?: (preset: UserFeedPreference, isCustom: boolean) => void;
}

export const PresetCard: React.FC<PresetCardProps> = ({
  preset,
  isActive,
  isCustom = false,
  icon,
  onSelect,
  onDelete,
  handleViewSettings
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      borderWidth={1}
      borderRadius="lg"
      p={4}
      cursor="pointer"
      transition="all 0.2s"
      minH="140px"
      minW="210px"
      h="auto"
      w="100%"
      onClick={onSelect}
      // bg={isActive ? "green.50" : "transparent"}
      border={'2px'}
      borderColor={isActive ? '#4CAF50' : 'gray.200'}
      _hover={{ borderColor: 'gray.300' }}
      position="relative"
      role="group"
    >
      <Flex alignItems="center" gap={2} mb={2} justifyContent="space-between">
        <Flex alignItems="center" gap={2} minWidth={0}>
          <Box bg="#EDF7EE" p={1.5} borderRadius="full">
            {icon}
          </Box>
          <Text fontWeight="medium" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
            {preset.name}
          </Text>
        </Flex>
        {isActive && (
          <div className="flex flex-row items-center gap-1">
            <Text color={'#4CAF50'} fontWeight={'bold'} fontSize={'12px'}>
              Active
            </Text>
            <Icon
              as={Check}
              strokeWidth={3}
              className="stroke-[#4CAF50] stoke- rounded-full border-[2px] border-[#4CAF50]"
            />
          </div>
        )}
      </Flex>
      <Text
        fontSize="sm"
        color="gray.600"
        whiteSpace="normal"
        display="-webkit-box"
        overflow="hidden"
        sx={{
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical'
        }}
      >
        {preset.description}
      </Text>
      <Text
        mt={'auto'}
        fontSize="sm"
        color="green.900"
        fontWeight={800}
        whiteSpace="normal"
        onClick={(e) => {
          e.stopPropagation();
          handleViewSettings?.({ ...preset, _isCustom: isCustom }, isCustom);
        }}
        _hover={{ color: 'green.500' }}
        cursor="pointer"
      >
        View settings
      </Text>

      {isCustom && onDelete && (
        <Button
          position="absolute"
          bottom={2}
          right={2}
          variant="ghost"
          size="sm"
          opacity={0}
          _groupHover={{ opacity: 1 }}
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
        >
          <Icon as={Trash2} color="gray.500" _hover={{ color: 'red.500' }} />
        </Button>
      )}
    </Box>
  );
};
